var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_832",
    "data-name": "Group 832",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.804,
    height: 36.354,
    viewBox: "0 0 29.804 36.354",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_425",
    "data-name": "Rectangle 425",
    width: 29.804,
    height: 36.354,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M32.842,30.048a6.9,6.9,0,0,0-3.287-.788,6.562,6.562,0,0,0-6.765,6.357c0,2.689,1.983,4.238,4.564,4.238a9.133,9.133,0,0,0,4.374-1.141l-.679,3.694a9.318,9.318,0,0,1-4.7.951,7.439,7.439,0,0,1-7.77-7.552,10.508,10.508,0,0,1,10.731-10.3A10.475,10.475,0,0,1,34.2,26.6Z",
    transform: "translate(-12.269 -16.847)",
    fill: "#40a629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M45.177,6.49,42.774,0,41.759,2.208A17.961,17.961,0,0,0,35.522,1.5a17.359,17.359,0,0,0-6.59,1.764,16.743,16.743,0,0,0-5.209,4.022q-.156.18-.307.364a.581.581,0,0,0,.829.805q.167-.137.337-.267a14.864,14.864,0,0,1,5.246-2.6,14.235,14.235,0,0,1,5.6-.353,13.639,13.639,0,0,1,4.315,1.356l-1.058,2.3Z",
    transform: "translate(-15.373 -0.001)",
    fill: "#40a629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M20.932,81.3q-.167.137-.337.268a14.863,14.863,0,0,1-5.246,2.6,14.222,14.222,0,0,1-5.6.353,13.643,13.643,0,0,1-4.316-1.356l1.058-2.3L0,83.262l2.4,6.489,1.014-2.207a17.972,17.972,0,0,0,6.238.708,17.357,17.357,0,0,0,6.59-1.764,16.745,16.745,0,0,0,5.208-4.022q.156-.18.307-.364a.581.581,0,0,0-.829-.806",
    transform: "translate(0 -53.397)",
    fill: "#40a629"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.812f380ba7729f0c4a9eca9d0c179935.svg";
export { ForwardRef as ReactComponent };